import React from 'react';

import Dash from '@dashboard/components/Dash';

/** An order's short ID as the dashboard shows it: "#27570135". */
export const formatOrderId = orderId => (orderId ? `#${orderId}` : null);

/** The ID column every order table starts with. */
export const orderIdColumn = {
  id: 'orderId',
  header: 'ID #',
  cell: ({ row }) =>
    row.original.orderId ? (
      <span className="whitespace-nowrap tabular-nums text-gray-900 dark:text-foreground">
        {formatOrderId(row.original.orderId)}
      </span>
    ) : (
      <Dash />
    ),
  enableSorting: false,
};
